import CreateCauseContainer from "../containers/CreateCauseContainer";

const CreateCausePage = () => {
  return (
    <CreateCauseContainer />
  );
};

export default CreateCausePage;
